import React, { PropTypes } from 'react';
import Select from 'react-select';

import './styles/BlockSelect.scss';

const BlockSelect = (props)=> {

    let inactive = false;

    const handleChange = (block)=> {
        props.onToggle(block.value)
    };

    /**
     * Get Current Block and return it
     * @returns {*}
     */
    const getCurrentOption = ()=> {
        const { options } = props;
        let value = [];

        value = options.filter(block=> {
            return block.value === props.blockType
        });

        if(value.length === 0) {
            inactive = true;
            return false;
        }

        inactive = false;

        return value[0];

    };

    const currentValue = getCurrentOption().value ? getCurrentOption().value : 'paragraph';

    console.log(props.options);

    return (
    <div className="block-select__wrapper">
        <div className="block-select">
            <Select
                name="draft-blocks"
                value={currentValue}
                options={props.options}
                disabled={inactive}
                onChange={handleChange}
                clearable={false}
                searchable={false}
            />
        </div>
    </div>
    )
};

BlockSelect.propTypes = {
    disabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    blockType: PropTypes.string.isRequired
};

BlockSelect.defatulProps = {
    disabled: false
};

export default BlockSelect;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/BlockSelect.js